import wx from "weixin-js-sdk";
import {
  getWxToken
} from "@/api";

const getBarCode = (resultStr) => {
  var serial = resultStr.split(",");
  var barCode = serial[serial.length - 1];
  return barCode;
}
export const initWxSDK = () => {
  //这里【url参数一定是去参的本网址】，请求后端接口换取signature
  // 我的代码是这样写的:(兼容安卓和ios)
  let url = window.location.href.split("#")[0];
  let ua = navigator.userAgent.toLowerCase();
  // if (/iphone|ipad|ipod/.test(ua)) {
  //     newUrl = url;
  // } else
  if (/android/.test(ua)) {
    url = window.location.href;
  }
  getWxToken({
    url
  }).then((res) => {
    const data = res.data;
    if (data.code == 200) {
      const jsondata = data.data;
      wx.config({
        // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        debug: false,
        // 必填，公众号的唯一标识
        appId: "wx1c6c804dc6a3c343",
        // 必填，生成签名的时间戳
        timestamp: "" + jsondata.timestamp,
        // 必填，生成签名的随机串
        nonceStr: jsondata.nonceStr,
        // 必填，签名
        signature: jsondata.signature,
        // 必填，需要使用的JS接口列表，所有JS接口列表
        jsApiList: ["scanQRCode"],
      });
    } else {}
  });
}
export const getScanCode = () => {
  return new Promise((resolve, reject) => {
    console.log("wx.scanQRCode - - -"); 
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: (res) => {
        console.log("res - - -", res);
        let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        let code = result.split(",");
        let data = ''
        if (code.length > 0) {
          data = code[code.length - 1]
        } else if (code.length === 1) {
          data = result
        }
        resolve(data)
      },
      fail: function(res) {
        console.error('扫描失败:', res);
      }
    })
  })

}



// WEBPACK FOOTER //
// ./src/utils/wxSDK.js